import gql from 'graphql-tag';

/** Get data to display the specified activity map */
export const ActivityMapQuery = gql`
    query ActivityMapQuery(
        $input: ActivityInput!
        $resolution: String!
        $streamTypes: [String]!
    ) {
        activity(input: $input) {
            id
            activity {
                id
                lngLatStream(resolution: $resolution) {
                    id
                    data
                }
                scalarStreams(
                    resolution: $resolution
                    streamTypes: $streamTypes
                ) {
                    id
                    activity_id
                    type
                    friendlyName
                    data
                    units
                    isEmpty
                    resolution
                }
            }
        }
    }
`;

/**
 * Get a collection of scalar streams for an activity from Strava,
 * with a specified resolution
 */
export const ActivityChartQuery = gql`
    query ActivityChartQuery(
        $input: ActivityInput!
        $resolution: String!
        $streamTypes: [String]!
    ) {
        activity(input: $input) {
            id
            activity {
                id
                scalarStreams(
                    resolution: $resolution
                    streamTypes: $streamTypes
                ) {
                    id
                    activity_id
                    type
                    friendlyName
                    data
                    units
                    isEmpty
                    resolution
                }
            }
        }
    }
`;

/**
 * Get the details of an activity from Strava, with statistics
 */
export const ActivityQuery = gql`
    query ActivityQuery($input: ActivityInput!) {
        activity(input: $input) {
            id
            activity {
                id
                name
                type
                location
                summaryPolyline
                timeSinceActivityInWords
                stats {
                    id
                    distance {
                        units
                        value
                    }
                    elapsedTime {
                        units
                        value
                    }
                    averageSpeed {
                        units
                        value
                    }
                    averagePace {
                        units
                        value
                    }
                }
            }
        }
    }
`;

/**
 * Get a paged collection of activities from Strava
 */
export const ActivityListQuery = gql`
    query ActivityListQuery($input: ActivityListInput) {
        activityList(input: $input) {
            activities {
                id
                activity {
                    id
                    name
                    type
                    location
                    summaryPolyline
                    timeSinceActivityInWords
                    stats {
                        id
                        distance {
                            units
                            value
                        }
                        elapsedTime {
                            units
                            value
                        }
                        averageSpeed {
                            units
                            value
                        }
                        averagePace {
                            units
                            value
                        }
                    }
                }
            }
            pageInfo {
                page
                pageSize
            }
        }
    }
`;

/** Update user settings for strava visualisation */
export const AthleteOptionsMutation = gql`
    mutation AthleteOptionsMutation($input: AthleteOptionsInput!) {
        athleteOptions(input: $input) {
            athlete {
                activityStreamTypes
                autoplayAnimation
                id
                resolution
                selectedActivityStreamType
                unitsPreference
            }
        }
    }
`;

/** Get athlete settings */
export const AthleteQuery = gql`
    query AthleteQuery {
        loggedInUser {
            id
            user {
                id
                username
                name
                isAdministrator
                athlete {
                    activityStreamTypes
                    autoplayAnimation
                    id
                    measurement_preference
                    profile
                    resolution
                    selectedActivityStreamType
                    unitsPreference
                }
                appStatus
            }
        }
        activityStreamInfoList {
            id
            activityStreamInfoList {
                id
                type
                friendlyName
                units
            }
        }
    }
`;

/** Get a collection of the available activitiy streams */
export const ActivityStreamInfoQuery = gql`
    query ActivityStreamInfoQuery {
        activityStreamInfoList {
            id
            activityStreamInfoList {
                id
                type
                friendlyName
                units
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/client/components/Strava/queries.ts